import requireAll from '@/helpers/requireAll';

export default {
	photos: requireAll(require.context('@/assets/views', false, /\.jpg$/)),
};
